import React from 'react';

import { Controller } from 'react-hook-form';

import { AdminTableList } from '../../../components/admin/AdminTableListPage/view';
import { InputV2 } from '../../../components/common/ui-kit/Input/view';
import ReactSelect from '../../../components/common/ui-kit/Select';
import { SynchStatus } from '../../../models/staff/import-tasks';
import { importTasksApi } from '../../../redux/api/staff/admin/import-tasks';
import { createInputV2Props } from '../../../utils/form-helpers';

export const renderApplicationStatesModifyFilter = ({
  control,
  formState: { errors },
}) => {
  const inputV2Props = createInputV2Props(errors);
  return (
    <>
      <>
        <Controller
          name="statuses"
          control={control}
          render={({ field }) => (
            <ReactSelect
              options={Object.entries(SynchStatus).map(value => ({
                value: value[0],
                label: value[1],
              }))}
              placeholder="Статус синхронизации"
              className="filter-form__field"
              {...field}
            />
          )}
        />
        <Controller
          name="createFromDate"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Дата создания от:"
              type="datetime-local"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
        <Controller
          name="createToDate"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Дата создания до:"
              type="datetime-local"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
        <Controller
          name="updateFromDate"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Дата обновления от:"
              type="datetime-local"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
        <Controller
          name="updateToDate"
          control={control}
          render={({ field }) => (
            <InputV2
              placeholder="Дата обновления до:"
              type="datetime-local"
              className="filter-form__field"
              {...inputV2Props(field)}
            />
          )}
        />
        <Controller
          name="hasError"
          control={control}
          render={({ field }) => (
            <ReactSelect
              options={[
                { label: 'Да', value: 'true' },
                { label: 'Нет', value: 'false' },
              ]}
              placeholder="Есть ошибка"
              className="filter-form__field"
              {...field}
            />
          )}
        />
      </>
    </>
  );
};

const ApplicationStatesModifyPage = () => {
  const detailsColumns = [
    {
      Header: 'ID заявления',
      accessor: 'applicationId',
    },
    {
      Header: 'ID КГ заявления',
      accessor: 'competitiveGroupId',
    },
    {
      Header: 'Причина',
      accessor: 'reasonRejectId',
    },
    {
      Header: 'Статус КГ',
      accessor: 'newStatus',
    },
    {
      Header: 'Статус синхронизации',
      accessor: 'syncStatus',
    },
    {
      Header: 'Комментарий к статусу',
      accessor: 'statusComment',
    },
    {
      Header: 'Номер заказчика',
      accessor: 'targetOrganizationNumber',
    },
  ];

  return (
    <AdminTableList
      storeKey="application-state-modify-entry"
      query={{
        use: importTasksApi.useGetApplicationStatusModifyQuery,
      }}
      columns={detailsColumns}
      filtersConfig={{
        defaultValues: {
          newStatus: '',
          hasError: '',
        },
        renderFilters: renderApplicationStatesModifyFilter,
      }}
    />
  );
};

export default ApplicationStatesModifyPage;
